import React, { useEffect, useState } from "react";
import {
  WEB_HOOD_VOICES,
  getWebHoodVoiceEnabled,
  getWebHoodVoiceId,
  setWebHoodVoiceEnabled,
  setWebHoodVoiceId,
  speakWebHoodVoice,
  stopWebHoodVoice,
} from "../utils/hoodWebSpeech";

function previewText(lang) {
  const value = String(lang || "en").toLowerCase();
  if (value.startsWith("pl")) return "Cześć. Jestem Hood. Będę spokojnie prowadzić cię przez trening szachowy.";
  if (value.startsWith("es")) return "Hola. Soy Hood. Te guiaré con calma durante tu entrenamiento de ajedrez.";
  return "Hi. I’m Hood. I’ll guide you calmly through your chess training.";
}

export default function HoodVoiceControls({
  lang = "en",
  compact = false,
  enabled: controlledEnabled,
  onEnabledChange,
}) {
  const [localEnabled, setLocalEnabled] = useState(() => getWebHoodVoiceEnabled());
  const [voiceId, setVoiceId] = useState(() => getWebHoodVoiceId());
  const enabled = typeof controlledEnabled === "boolean" ? controlledEnabled : localEnabled;

  useEffect(() => {
    const onVoice = (event) => {
      if (typeof event?.detail?.enabled === "boolean") setLocalEnabled(event.detail.enabled);
    };
    const onChoice = (event) => {
      if (event?.detail?.voice) setVoiceId(event.detail.voice);
    };
    window.addEventListener("chesshood:hood-voice", onVoice);
    window.addEventListener("chesshood:hood-voice-choice", onChoice);
    return () => {
      window.removeEventListener("chesshood:hood-voice", onVoice);
      window.removeEventListener("chesshood:hood-voice-choice", onChoice);
    };
  }, []);

  const toggle = () => {
    const next = !enabled;
    setLocalEnabled(next);
    setWebHoodVoiceEnabled(next);
    onEnabledChange?.(next);
    if (!next) stopWebHoodVoice();
    else speakWebHoodVoice(previewText(lang), lang, { voiceId });
  };

  const chooseVoice = (event) => {
    const next = setWebHoodVoiceId(event.target.value);
    setVoiceId(next);
    if (enabled) speakWebHoodVoice(previewText(lang), lang, { voiceId: next });
  };

  return (
    <div
      className="hood-web-voice-controls"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: compact ? 6 : 8,
        flexWrap: "wrap",
      }}
    >
      <button
        type="button"
        onClick={toggle}
        aria-pressed={enabled}
        title={enabled ? "Turn Hood voice off" : "Turn Hood voice on"}
        style={{
          minHeight: compact ? 34 : 38,
          borderRadius: 999,
          border: "1px solid rgba(125,211,252,.56)",
          background: enabled ? "rgba(14,116,144,.18)" : "rgba(255,255,255,.05)",
          color: enabled ? "#7dd3fc" : "#afc2d8",
          padding: compact ? "7px 10px" : "9px 12px",
          fontSize: compact ? 11 : 12,
          fontWeight: 900,
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        {enabled ? "🔊 Voice on" : "🔇 Voice off"}
      </button>

      <select
        value={voiceId}
        onChange={chooseVoice}
        aria-label="Choose Hood voice"
        title={WEB_HOOD_VOICES.find((voice) => voice.id === voiceId)?.description || "Choose Hood voice"}
        style={{
          minHeight: compact ? 34 : 38,
          maxWidth: compact ? 150 : 190,
          borderRadius: 999,
          border: "1px solid rgba(255,213,116,.38)",
          background: "#0b1830",
          color: "#f8fafc",
          padding: compact ? "6px 10px" : "8px 11px",
          fontSize: compact ? 11 : 12,
          fontWeight: 800,
          outline: "none",
        }}
      >
        {WEB_HOOD_VOICES.map((voice) => (
          <option key={voice.id} value={voice.id}>
            {voice.label} · {voice.description}
          </option>
        ))}
      </select>
    </div>
  );
}
